/// <reference path="../../typings/moment/moment.d.ts" />

import { Pipe, PipeTransform } from "@angular/core";
import { DateExtensions } from "../utilities/date.extensions";
import { UserStorageService } from "../services/user-storage.service";

@Pipe({	name: "datex" })

export class DatexPipe implements PipeTransform {
	constructor( private userStorageService: UserStorageService	) { }

	transform(value: any, format: string = ""): string {
		// add timezone offset
		if (this.userStorageService.user && this.userStorageService.user.timeZoneOffset) {
			value = DateExtensions.addTimezoneOffset(new Date(value), this.userStorageService.user.timeZoneOffset)
		}

		// Try and parse the passed value.
		let momentDate = moment(value);

		// If moment didn't understand the value, return it unformatted.
		if (!momentDate.isValid()) return value;

		// Otherwise, return the date formatted as requested.
		return momentDate.format(format);
	}
}